import React from 'react';
// import videojs from 'video.js';
// import 'video.js/dist/video-js.css';
// import 'videojs-contrib-quality-levels';
import PlayIcon from '@mui/icons-material/PlayCircle';
import _ from "videojs-contrib-quality-levels";
import qualitySelector from "videojs-hls-quality-selector";
import Plyr from 'plyr';
import Hls from 'hls.js';
import 'plyr/dist/plyr.css'; // Import Plyr CSS
import logo from '../../assets/logo.png'
import { baseUrl } from '../../constants';

const DE = async (data) => {
  const base64Key = 'iHqqoYVE2NR6S7ug4uqpzVUmti0o8OCUco2Ak2qbfFE='; // Replace with your key
  const base64IV = 'LbLSNSFIUiXDEyEK+Y38Ew=='; // Replace with your IV

  // Decode the key and IV from Base64
  const key = Uint8Array.from(atob(base64Key), c => c.charCodeAt(0));
  const iv = Uint8Array.from(atob(base64IV), c => c.charCodeAt(0));
  const cryptoKey = await crypto.subtle.importKey(
    'raw', // Key format
    key, // Decoded key
    { name: 'AES-CBC' }, // Algorithm
    false, // Whether the key is extractable
    ['decrypt'] // Key usage
  );

  // Decrypt the data
  try {
  const decryptedData = await crypto.subtle.decrypt(
    {
      name: 'AES-CBC', // Algorithm
      iv: iv, // Initialization Vector
    },
    cryptoKey, // Key
    data // Encrypted data
  );
  return decryptedData;
  } catch(e){
    console.log('eee', e)
    return null
  }

  
}

class CustomFragmentLoader extends Hls.DefaultConfig.loader {
  constructor(config) {
      super(config);
      var load = this.load.bind(this);
      this.load = function (context, config, callbacks) {
       
          var onSuccess = callbacks.onSuccess;
          callbacks.onSuccess = async function (response, stats, context) {
            console.log('aaa', response)
            response.data = await DE(response.data);
            onSuccess(response, stats, context);
          };
          load(context, config, callbacks);
      };

  }

  // async load(fragment, progressCallback) {
  //     // Call the original load method to fetch the segment
  //     const response = await super.load(fragment, progressCallback);

  //     // Decrypt the segment data
  //     try {
  //       console.log(response)
  //         const decryptedData = await this.decryptSegment(response.data);
  //         response.data = decryptedData; // Replace the payload with decrypted data
  //     } catch (e) {
  //         console.error('Decryption failed:', e);
  //         throw e; // Re-throw the error to stop playback
  //     }

  //     return response;
  // }

  async decryptSegment(data) {
      // Your custom decryption logic here
      // Example: Assuming DE is your decryption function
      return await DE(data); // Ensure DE returns an ArrayBuffer
  }
}
// videojs.registerPlugin("qualityLevels", _);
// videojs.registerPlugin("hlsQualitySelector", qualitySelector);


export const VideoJS = (props) => {
  const videoRef = React.useRef(null);
  const playerRef = React.useRef(null);
  const playRef = React.useRef(null);
  const {options, style} = props;
  const [player, setPlayer] = React.useState(null)
  console.log(options)

  React.useEffect(() => {
    
    // if (mPlayer) {
      
    //   mPlayer.hlsQualitySelector({ displayCurrentQuality: true });
    // }
    // return () => {
    //   if (plyr) {
    //     plyr.destroy();
    //   }
    // };

  }, []); // [mPlayer]
  // function onReady(_player) {
  //   alert(_player.qualityLevels())
  //   // _player.src({p
  //   //   src: liveURL,
  //   //   type: "application/x-mpegURL",
  //   //   withCredentials: false
  //   // });
  //   // this.hlsQualitySelector({ displayCurrentQuality: true });
  // }

  // React.useEffect(() => {

  //   // Make sure Video.js player is only initialized once
  //   if (!playerRef.current) {
  //     // The Video.js player needs to be _inside_ the component el for React 18 Strict Mode. 
  //     const videoElement = document.createElement("video-js");

  //   //   videoElement.classList.add('vjs-big-play-centered');
  //     videoElement.style.height = '200px !important'
  //     videoElement.style.width = '200px !important'
  //     videoRef.current.appendChild(videoElement);

  //     const handlePlayerReady = (player) => {
  //       playerRef.current = player;

  //       // You can handle player events here, for example:
  //       player.on('waiting', () => {
  //           console.log('player is waiting');
  //       });

  //       player.on('dispose', () => {
  //           console.log('player will dispose');
  //       });
  //   };

  //     const player = playerRef.current = videojs(videoElement, options, function(){
  //       videojs.log('player is ready');
  //       var _player = this
        
  //       // onReady(player);
  //     });
      
  //     setMPlayer(player)

  //     // const qualityButton = player.controlBar.addChild('button', {
  //     //   text: 'Quality',
  //     //   class: 'vjs-quality-button',
  //     // });

  //     // qualityButton.on('click', () => {
  //     //   console.log(player)
  //     // });

  //     player.on('play', () => {
  //       playRef.current.style.display = 'none'
  //       // Your custom logic when the video starts playing
  //     });
  
  //     player.on('pause', () => {
  //       playRef.current.style.display = 'flex'
  //       // Your custom logic when the video is paused
  //     });
      
  //   // You could update an existing player in the `else` block here
  //   // on prop change, for example:
  //   } else {
  //     const player = playerRef.current;

  //     player.autoplay(options.autoplay);
  //     player.src(options.sources);
  //   }
  // }, [options, videoRef]);

  // Dispose the Video.js player when the functional component unmounts
  // React.useEffect(() => {
  //   const player = playerRef.current; 

  //   return () => {
  //     if (player && !player.isDisposed()) {
  //       player.dispose();
  //       playerRef.current = null;
  //     }
  //   };
  // }, [playerRef]);

  const source = options.source.url
  console.log(options, '*******99999')

  

  React.useEffect(() => {
    if (!videoRef.current || !source) return;
  
    let hls;
    const defaultOptions = {};

    console.log('yesss', source, Hls.isSupported() || /Safari/.test(navigator.userAgent))
    if (Hls.isSupported()) {
      
      hls = new Hls({debug: true, fLoader: CustomFragmentLoader});
      hls.loadSource(source);
      hls.attachMedia(videoRef.current);

      hls.on(Hls.Events.FRAG_LOADED, async (event, data) => {
        const segmentData = data.payload; // ArrayBuffer of the segment
        try {
          console.log(data.payload)
          const dd = await DE(segmentData); // Your custom decryption function
          console.log('Decrypted payload starts with:', dd);
          data.payload = dd;
        } catch(e){
          console.log(e)
        }
      })

      hls.on(Hls.Events.ERROR, (event, data) => {
        console.error('HLS error:', data);
      });
      
      // videoRef.current.play()
  
      hls.on(Hls.Events.MANIFEST_PARSED, () => {
        // Add quality levels to the Plyr settings menu
        
        const levels = hls.levels;
        console.log('hooo', player)
        // player.on('ready', () => {
          console.log(hls.levels)
          // const qualityOptions = levels.map((level, index) => ({
          //   label: `${level.height}p`,
          //   value: index,
          // }));
          // player.options.quality = qualityOptions
        // });
        // hls.on(Hls.Events.MANIFEST_PARSED, function (event, data) {

          // Transform available levels into an array of integers (height values).
          const availableQualities = hls.levels.map((l) => l.height)
          availableQualities.unshift(0)
    
          // Add new qualities to option
          defaultOptions.quality = {
            default: availableQualities[0],
            options: availableQualities,
            // this ensures Plyr to use Hls to update quality level
            // Ref: https://github.com/sampotts/plyr/blob/master/src/js/html5.js#L77
            forced: true,        
            onChange: (newQuality) => {
              let ct = videoRef.current.currentTime;
              if(newQuality == 0){
                hls.currentLevel = -1;
                if(ct > 1) setTimeout(() => videoRef.current.currentTime -= 1, 500)
              } else {
                hls.levels.forEach((level, levelIndex) => {
                  if (level.height === newQuality) { 
                    console.log("Found quality match with " + newQuality,  hls.currentLevel, levelIndex, hls.setCurrentLevel);
                    hls.currentLevel = levelIndex;
                    if(ct > 1) setTimeout(() => videoRef.current.currentTime -= 1, 500)
                  }
                });
              }
            }
          }
          // Initialize new Plyr player with quality options
          // const player = new Plyr(videoRef, defaultOptions);
          const plyr = new Plyr(videoRef.current, {
            ...defaultOptions,
            autoplay: true,
            i18n: {
              qualityLabel: {
                0: 'Auto',
              }
            },
            previewThumbnails: { enabled: true, src: baseUrl + options.source.previewThumbnail },
            controls: [
              'play',
              'progress',
              'current-time',
              'mute',
              'volume',
              'captions',
              'settings',
              'pip',
              'airplay',
              'fullscreen'
            ],
          });
          plyr.on('controlsshown', (event) => {
            // Example: Add a custom button to the controls
            if(!document.getElementById('player-huluware')){
              const hulluimg = document.createElement('img');
              hulluimg.id = 'player-huluware';
              hulluimg.src = logo;
              hulluimg.style.cssText = 'width: 35px; height: 45px; object-fit: contain;'
              hulluimg.addEventListener('click', () => {
                  alert('Player Secured by HulluWare!');
              });

              // Append the custom button to the controls
              const controlsContainer = document.querySelector('.plyr__controls');
              if(controlsContainer) controlsContainer.appendChild(hulluimg);
            }
            
        })
          setPlayer(plyr)
        // })
  
        // Handle quality change
        // player.on('settingchange', (event) => {
        //   if (event.detail.setting === 'quality') {
        //     hls.currentLevel = event.detail.value;
        //   }
        // });
      });
    } else if (videoRef.current.canPlayType('application/vnd.apple.mpegurl')) {
      videoRef.current.src = source;
    } else {
      console.error('HLS is not supported in this browser.');
    }
  
    return () => {
      if (hls) {
        hls.destroy();
      }
    };
  }, [source]);


  return (
      <div style={{
        width: '100%',
        maxWidth: '960px',
        aspectRatio: '16 / 9',
        position: 'relative'
      }}>
        <video style={{
          backgroundColor: '#000',
          width: '100%', height: '100%'
      }} ref={videoRef} controls crossOrigin="true" />
      </div>
  );
}

export default VideoJS;